module.exports = __webpack_public_path__ + "static/media/Salary60k.5f25cd0d.png";